import { MoldColorConfiguration } from "constants"
import React, { useRef } from "react"
import { useDrag, useDrop } from "react-dnd"

const ItemType = "COLOR"

const DraggableColors = ({ color, index, moveColor, removeColor }) => {
   const ref = useRef(null)

   const [, drop] = useDrop({
      accept: ItemType,
      hover(item) {
         if (item.index === index) return
         moveColor(item.index, index)
         item.index = index
      },
   })

   const [, drag] = useDrag({
      type: ItemType,
      item: { index },
   })

   drag(drop(ref))

   return (
      <div ref={ref} className="selected-color-badge">
         <div className="drag-handle">
            <span className="dots">⋮</span>
         </div>
         <div
            className={`color-square mould-color-${color.value.toLowerCase()}`}
         />
         <span className="color-label">
            {MoldColorConfiguration.getDisplayTextKey(color.value)}
         </span>
         <button
            type="button"
            className="remove-color-btn"
            onClick={() => removeColor(index)}
         >
            &times;
         </button>
      </div>
   )
}

export default DraggableColors
